export default __webpack_public_path__ + "static/media/936.53117cf3.png";